import { msg } from "@lingui/core/macro";

export const bufferTimeBetweenPermitsRuleMessages = {
	name: msg({ message: "Buffer Between Permits" }),
	description: msg({
		message: "Requires a minimum gap between a vehicle's previous permit ending and the next one starting",
	}),
	errors: {
		bufferNotMet: msg({
			message: "Please leave at least {duration} between the end of one permit and the start of the next.",
		}),
		alreadyRegistered: msg({ message: "Vehicle is on permit list, no need to register." }),
	},
} as const;
